import api from "../axios";

/*
|--------------------------------------------------------------------------
| GET CATEGORIES
|--------------------------------------------------------------------------
*/

export const getCategoriesApi = (activeOnly = true) => {
  return api.get("/categories", {
    params: {
      activeOnly
    }
  });
};


/*
|--------------------------------------------------------------------------
| GET SINGLE CATEGORY
|--------------------------------------------------------------------------
*/

export const getCategoryApi = (id) => {
  return api.get(`/categories/${id}`);
};


/*
|--------------------------------------------------------------------------
| CREATE CATEGORY
|--------------------------------------------------------------------------
*/

export const createCategoryApi = (data) => {
  return api.post("/categories", data);
};


/*
|--------------------------------------------------------------------------
| UPDATE CATEGORY
|--------------------------------------------------------------------------
*/

export const updateCategoryApi = (id, data) => {
  return api.patch(`/categories/${id}`, data);
};


/*
|--------------------------------------------------------------------------
| DELETE CATEGORY
|--------------------------------------------------------------------------
*/

export const deleteCategoryApi = (id) => {
  return api.delete(`/categories/${id}`);
};